import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { appVersion } from './app/app.settings';

console.log(`Dealer v${appVersion || 'unknown'}`);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
